import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from  'rxjs'
import { AuthService } from 'app/auth/auth.service';
import { DatePipe } from '@angular/common';
import { IApptType, IGetServiceData } from './addappointment.component';
import { DashboardService } from 'app/dashboard/dashboard.service';
 
@Injectable({
  providedIn: 'root'
})
export class addppointmentservice {
   // baseUrl:string = "http://49.50.108.154:7575/api/";
    //baseUrl:string = "http://localhost:54923/api/";
    public times:string;
    constructor(public http: HttpClient, public dashboardService: DashboardService) { }
       
    ApptType_info() : Observable<IApptType[]>
    {
     
      // 
      //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
      return this.http.get<IApptType[]>(this.dashboardService.newbaseUrl+"OpdAppointmentTypeMaster/GetApptType");
    
    }

    GetServiceData() : Observable<IGetServiceData[]>
    {
      
      // 
      //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
      return this.http.get<IGetServiceData[]>(this.dashboardService.newbaseUrl+"ServiceMaster/GetServiceAll");
    
    }
    
}